import { useEffect } from 'react';
import { buildMypageProfilePath, navigate } from './api';

/** @deprecated /mypage/profile?tab=charge 으로 리다이렉트 */
export default function OneliveMobileMypageChargeHistoryPage() {
  useEffect(() => {
    navigate(buildMypageProfilePath('charge'));
  }, []);
  return null;
}
